import { getTextField } from '@lender/utils';
import { object } from 'yup';

export const schema = object().shape({
  product: getTextField({ isRequired: false }),
});
